import { createSlice } from '@reduxjs/toolkit';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { createAsyncThunk } from "@reduxjs/toolkit"

import { AsyncThunkAction, AsyncThunkActionWithFetch } from '../asyncThunk';
import { HttpRequestType } from "../../adapters/xhr/RequestStatus";
import { AppToast } from '../../lib/toast';
import { getConfiguredLabel } from '../../common/commonHelper';
import { DocumentsPage, downloadSuccessfulMessage, success } from '../../common/labelConstants';
import { downloadFile } from '../../common/download';
const initialState = {
    documents: []
}


export const saveDocuments = AsyncThunkAction('document/uploadSave', API_BASE_URL + ApiURLs.Document.SaveUploadedDocuments)
export const getDocuments = AsyncThunkAction('document/getDocuments', API_BASE_URL + ApiURLs.Document.getDocuments)
export const editDocuments = AsyncThunkAction('document/edit', API_BASE_URL + ApiURLs.Document.editdocuments)
export const deleteDocuments = AsyncThunkAction('document/delete', API_BASE_URL + ApiURLs.Document.deleteMultipleDocs, HttpRequestType.DELETE)
export const getDocFormatGraphInfo = AsyncThunkAction('document/analytics/docformat', API_BASE_URL + ApiURLs.Document.analytics.docFormat)
export const getDocsUploadedGraphInfo = AsyncThunkAction('/documents/analytics/docsuploaded', API_BASE_URL + ApiURLs.Document.analytics.uploadedcount)


// export const downloadDocuments = AsyncThunkActionWithFetch('document/download', API_BASE_URL + ApiURLs.Document.downloadDocs)
export const downloadDocuments = createAsyncThunk('document/download', async (payload, { signal, getState }) => {
    const token = getState().auth.token
    const url = API_BASE_URL + ApiURLs.Document.downloadDocs
    const onSuccessCallBack=()=>{
               AppToast.Toast.success({ title:getConfiguredLabel(DocumentsPage,success) , message:  getConfiguredLabel(DocumentsPage,downloadSuccessfulMessage) })
    }
    const onErrorCallBack=()=>{
             AppToast.Toast.error({title: "Download Failed", message:"Unexpected error occurred."})
    }
    return await downloadFile(url,payload,token,onSuccessCallBack,onErrorCallBack)
});








const documentslice = createSlice({
    name: 'document',
    initialState: initialState,
    reducers: {
        setDocumentData: (state, action) => {
            state.documents = action.payload
        }
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(saveDocuments.pending, (state, action) => {
    //             // state.userInfo.status = RequestStatus.Pending;


    //         }).addCase(saveDocuments.fulfilled, (state, action) => {
    //             if (action.payload.status == 200) {

    //             }
    //             if (action.payload.status == 500) {

    //             }
    //         }).addCase(saveDocuments.rejected, (state, action) => {

    //         })
    // }
})

export const { setDocumentData } = documentslice.actions;
export default documentslice.reducer